export enum ConfigurationActionTypes {
	SET_CULTURE_FORMAT = 'SET_CULTURE_FORMAT',
	SET_DEFAULT_DATA = 'SET_DEFAULT_DATA',
	SET_CHECKBOX_SETTING_VALUE = 'SET_CHECKBOX_SETTING_VALUE',
	SET_SETTING_VALUE = 'SET_SETTING_VALUE',
	SET_VIEW_SETTING_VALUE = 'SET_VIEW_SETTING_VALUE',
	SET_SETTINGS_HAVE_CHANGED = 'SET_SETTINGS_HAVE_CHANGED',
}
